"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var verifyCaptcha = function verifyCaptcha(response) {
  var url = 'https://api-stage.crescolabsdev.com';
  var apiKey = 'YAU0LT8LFsaqiVa40rlUCj8ASanm1sXB8IK6pRg0';

  if (!window.location.hostname.includes('localhost') || !window.location.hostname.includes('crescolabsdev')) {
    url = 'https://api.crescolabs.com';
    apiKey = 'Vf6UwRmu9E7beVqVU6ThG3ekrmtbUwlZDpYxqMc6';
  }

  var apiPath = '/p/verify-captcha';
  var options = {
    headers: {
      'x-api-key': apiKey,
      'Content-Type': 'application/json'
    }
  };
  var data = {
    token: response
  };
  return _axios.default.post(url + apiPath, data, options).then(function (response) {
    return response.data.data;
  }).catch(function (error) {
    return 'FAIL';
  });
};

var _default = verifyCaptcha;
exports.default = _default;